<template>
  <div class="bg-black">
    <!-- Hero Section start -->
    <section class="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-black pb-20">

      <!-- Background Image spans full width -->
      <div class="absolute inset-0 z-0">
        <img src="../assets/hero-image.png" class="w-full h-full object-cover opacity-40" alt="hero background">
        <div class="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-black"></div>
      </div>

      <!-- Contrained Container for Assets and Content -->
      <div class="max-w-7xl mx-auto w-full h-full relative z-10 flex flex-col items-center justify-center pt-32 md:pt-24 lg:pt-20">
        <!-- Floating Assets constrained to 6xl -->
        <div class="absolute inset-0 pointer-events-none">
          <!-- Coins (Top Left-ish) -->
          <Motion as="img"
            :initial="{ opacity: 0 }"
            :animate="{ opacity: 1 }"
            :transition="{ duration: 1 }"
            class="hidden lg:block absolute top-[18%] left-[2%] w-20 md:w-32 animate-float drop-shadow-[0_0_25px_#FF3B3BCC]" 
            :src="require('../assets/coins.png')" alt="coins" />
          
          <!-- Black Card (Top Right) -->
          <Motion as="img"
            :initial="{ opacity: 0, rotate: 35, scale: 0.8 }"
            :animate="{ opacity: 1, scale: 1 }"
            :transition="{ duration: 1, delay: 0.2 }"
            class="hidden lg:block absolute top-[8%] right-[2%] w-40 md:w-60 animate-float-delayed drop-shadow-[0_0_35px_#FFD16680]" 
            :src="require('../assets/black-card.png')" alt="black card" />

          <!-- Red Card (Bottom Left) -->
          <Motion as="img"
            :initial="{ opacity: 0, rotate: -35, scale: 0.8 }"
            :animate="{ opacity: 1, scale: 1 }"
            :transition="{ duration: 1, delay: 0.4 }"
            class="hidden lg:block absolute bottom-[10%] left-[-2%] w-44 md:w-72 animate-float drop-shadow-[0_0_35px_#FFD16680]" 
            :src="require('../assets/red-card.png')" alt="red card" />

          <!-- Dice (Bottom Right-ish) -->
          <Motion as="img"
            :initial="{ opacity: 0, rotate: 15, scale: 0.8 }"
            :animate="{ opacity: 1, scale: 1 }"
            :transition="{ duration: 1, delay: 0.6 }"
            class="hidden lg:block absolute bottom-[22%] right-[5%] w-24 md:w-36 animate-float-delayed drop-shadow-[0_0_25px_#FFD16680]" 
            :src="require('../assets/dice.png')" alt="dice" />
        </div>

        <!-- Main Content -->
        <div class="relative z-20 flex flex-col items-center text-center px-6">
          <Motion as="img"
            :initial="{ scale: 0, opacity: 0 }"
            :animate="{ scale: 1, opacity: 1 }"
            :transition="{ type: 'spring', stiffness: 260, damping: 20 }"
            :src="require('../assets/vivstream-logo.png')" class="w-44 md:w-64 mb-6 md:mb-8 drop-shadow-[0_0_15px_rgba(255,0,0,0.3)]" alt="VIV Logo" />
          
          <Motion as="h1"
            :initial="{ y: 20, opacity: 0 }"
            :animate="{ y: 0, opacity: 1 }"
            :transition="{ duration: 0.8, delay: 0.2 }"
            class="text-4xl md:text-7xl font-black tracking-tighter uppercase mb-4 md:mb-6">
            <span class="text-white">SPIN. WIN. </span>
            <span class="text-red-600 drop-shadow-[0_0_10px_rgba(220,38,38,0.5)]">DOMINATE.</span>
          </Motion>

          <Motion as="p"
            :initial="{ y: 20, opacity: 0 }"
            :animate="{ y: 0, opacity: 1 }"
            :transition="{ duration: 0.8, delay: 0.4 }"
            class="text-gray-300 text-sm md:text-lg max-w-2xl mb-8 md:mb-12 font-medium">
            Join VIVSTREAMS for exclusive high-stakes action, daily giveaways, and the best community in online gaming.
          </Motion>

          <Motion as="div"
            :initial="{ y: 20, opacity: 0 }"
            :animate="{ y: 0, opacity: 1 }"
            :transition="{ duration: 0.8, delay: 0.5 }"
            class="flex flex-col sm:flex-row gap-4 mb-10 md:mb-14">
            <a href="https://roobet.com/?ref=viv" target="_blank" class="bg-red-600 hover:bg-red-500 text-white px-10 py-4 rounded-xl font-black uppercase tracking-widest transition-all shadow-[0_0_30px_rgba(220,38,38,0.4)] active:scale-95 text-center inline-block">
              Claim Bonus
            </a>
            <a href="https://kick.com/vivstreams" target="_blank" class="bg-transparent border-2 border-[#E53935] hover:bg-[#E53935]/10 text-[#E53935] px-10 py-4 rounded-xl font-black uppercase tracking-widest transition-all backdrop-blur-sm active:scale-95 text-center inline-block">
              Watch Live
            </a>
          </Motion>

          <!-- Stats -->
          <Motion as="div"
            :initial="{ y: 20, opacity: 0 }"
            :animate="{ y: 0, opacity: 1 }"
            :transition="{ duration: 0.8, delay: 0.6 }"
            class="grid grid-cols-3 gap-8 md:gap-20 border-t border-white/10 pt-8 md:pt-10">
            <div class="flex flex-col">
              <span class="text-white text-xl md:text-3xl font-black">$50k</span>
              <span class="text-gray-500 text-[10px] md:text-xs uppercase font-bold tracking-widest">Given Away</span>
            </div>
            <div class="flex flex-col border-x border-white/10 px-8 md:px-20">
              <span class="text-white text-xl md:text-3xl font-black">50K+</span>
              <span class="text-gray-500 text-[10px] md:text-xs uppercase font-bold tracking-widest">Community</span>
            </div>
            <div class="flex flex-col">
              <span class="text-white text-xl md:text-3xl font-black">24/7</span>
              <span class="text-gray-500 text-[10px] md:text-xs uppercase font-bold tracking-widest">Support</span>
            </div>
          </Motion>
          
          <!-- Roobet Button -->
          <Motion as="div"
            :initial="{ scale: 0.8, opacity: 0 }"
            :animate="{ scale: 1, opacity: 1 }"
            :transition="{ type: 'spring', delay: 0.7 }"
            class="mt-8 md:mt-10">
            <a href="https://roobet.com/?ref=viv" target="_blank" class="block transition-transform duration-300 hover:scale-[1.05] active:scale-95">
              <img src="../assets/roobet-button.png" class="w-48 md:w-64 h-auto" alt="Roobet Button">
            </a>
          </Motion>
        </div>
      </div>
    </section>
    <!-- Hero Section end -->
 
    <!-- Promotions Section -->
    <section class="lg:min-h-screen bg-black pt-40 pb-24 px-6" id="promotions">
      <div class="max-w-7xl mx-auto flex flex-col items-center">
        <!-- Section Header -->
        <Motion :initial="{ y: 50, opacity: 0 }" :in-view="{ y: 0, opacity: 1 }" :in-view-options="{ once: true }" :transition="{ duration: 0.6 }" class="text-center mb-16">
          <h2 class="text-4xl md:text-5xl font-black uppercase tracking-tighter mb-4">
            <span class="text-white">CURRENT </span>
            <span class="text-red-600">PROMOTIONS</span>
          </h2>
          <p class="text-gray-400 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Boost your bankroll with our exclusive offers. From welcome bonuses to VIP rewards, we've got you covered.
          </p>
        </Motion>

        <!-- Promotions Grid -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-10 w-full max-w-5xl mx-auto px-10 md:px-0">
          <Motion as="a" href="https://roobet.com/?ref=viv" target="_blank"
            :initial="{ y: 50, opacity: 0 }"
            :in-view="{ y: 0, opacity: 1 }"
            :in-view-options="{ once: true }"
            :transition="{ duration: 0.6 }"
            class="block group relative cursor-pointer rounded-3xl overflow-hidden bg-zinc-900 transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_0_30px_#E53935]">
            <img src="../assets/Promotion-1.png" class="w-full h-auto object-cover" alt="Welcome Bonus">
          </Motion>

          <!-- Promotion 2 -->
          <Motion as="a" href="https://roobet.com/?ref=viv" target="_blank"
            :initial="{ y: 50, opacity: 0 }"
            :in-view="{ y: 0, opacity: 1 }"
            :in-view-options="{ once: true }"
            :transition="{ duration: 0.6, delay: 0.1 }"
            class="block group relative cursor-pointer rounded-3xl overflow-hidden bg-zinc-900 transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_0_30px_#E53935]">
            <img src="../assets/Promotion-2.png" class="w-full h-auto object-cover" alt="VIP High Roller">
          </Motion>

          <!-- Promotion 3 -->
          <Motion as="a" href="https://roobet.com/?ref=viv" target="_blank"
            :initial="{ y: 50, opacity: 0 }"
            :in-view="{ y: 0, opacity: 1 }"
            :in-view-options="{ once: true }"
            :transition="{ duration: 0.6, delay: 0.2 }"
            class="block group relative cursor-pointer rounded-3xl overflow-hidden bg-zinc-900 transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_0_30px_#E53935]">
            <img src="../assets/Promotion-3.png" class="w-full h-auto object-cover" alt="Weekly Cashback">
          </Motion>
        </div>
      </div>
    </section>

    <!-- Leaderboard Section -->
    <section class="min-h-screen bg-black py-24 px-6" id="leaderboard">
      <div class="max-w-7xl mx-auto flex flex-col items-center">
        <!-- Section Header -->
        <Motion :initial="{ y: 50, opacity: 0 }" :in-view="{ y: 0, opacity: 1 }" :in-view-options="{ once: true }" :transition="{ duration: 0.6 }" class="text-center mb-12">
          <div class="flex items-center justify-center gap-2 sm:gap-4 mb-4">
            <img src="../assets/throphy.png" class="w-auto h-7 sm:h-12 md:h-16" alt="trophy">
            <h2 class="text-2xl sm:text-4xl md:text-6xl font-black uppercase tracking-tighter leading-none whitespace-nowrap">
              <span class="text-white">ROOBET</span>
              <span class="text-red-600 ml-1.5 sm:ml-2">LEADERBOARD</span>
            </h2>
          </div>

          <!-- Total Prize Pool -->
          <Motion :initial="{ scale: 0.8, opacity: 0 }" :in-view="{ scale: 1, opacity: 1 }" :in-view-options="{ once: true }" :transition="{ type: 'spring' }" class="flex flex-col items-center mb-8">
            <span class="text-red-500 font-black uppercase tracking-[0.3em] text-[10px] md:text-xs mb-1">Total Prize Pool</span>
            <div class="text-6xl md:text-8xl font-black text-white tracking-tighter drop-shadow-[0_0_25px_rgba(220,38,38,0.5)] flex items-center gap-4">
              <span class="text-red-600">$</span>
              <span class="text-white">{{ animatedTotalPrize.toLocaleString() }}</span>
            </div>
          </Motion>

          <p class="text-gray-400 text-sm md:text-lg font-medium tracking-wide">
            The biggest winners of the month. Will you be next?
          </p>
        </Motion>

        <!-- Timer Box -->
        <Motion :initial="{ scale: 0.9, opacity: 0 }" :in-view="{ scale: 1, opacity: 1 }" :in-view-options="{ once: true }" :transition="{ type: 'spring' }" class="w-full max-w-xl bg-gradient-to-b from-[#0F0F0F] to-[#B71C1C]/50 border-2 border-[#B71C1C] rounded-[32px] p-4 md:p-8 mb-8 relative shadow-[0_0_50px_rgba(183,28,28,0.3)]">
          <div class="flex flex-col items-center justify-center">
            <div class="flex items-center gap-3 mb-6">
              <img src="../assets/clock.png" class="w-5 h-5 md:w-6 md:h-6" alt="clock">
              <span class="text-white font-black uppercase tracking-[0.2em] text-sm md:text-lg">Competition Ends In:</span>
            </div>
            
            <div class="flex gap-2 md:gap-4 justify-center w-full">
              <div v-for="seg in timeSegments" :key="seg.label" 
                class="w-16 h-20 md:w-24 md:h-28 bg-[#0a0a0a]/90 rounded-xl flex flex-col items-center justify-center shadow-2xl border border-white/5">
                <div 
                  :class="seg.label === 'SEC' ? 'text-[#E53935]' : 'text-[#F5C16C]'"
                  class="text-2xl md:text-5xl font-black leading-none">
                  {{ (loading || leaderboardView === 'previous') ? '00' : seg.value.padStart(2, '0') }}
                </div>
                <span class="text-gray-400 text-[10px] md:text-xs font-medium mt-1">
                  {{ seg.label === 'DAYS' ? 'Days' : seg.label === 'HRS' ? 'Hours' : seg.label === 'MIN' ? 'Minutes' : 'Seconds' }}
                </span>
              </div>
            </div>
          </div>
        </Motion>

        <!-- Leaderboard Switcher -->
        <div v-if="showPrevious" class="flex items-center gap-2 mb-12 bg-zinc-900/50 p-1.5 rounded-full border border-white/5 whitespace-nowrap">
          <button 
            @click="leaderboardView = 'current'"
            :class="leaderboardView === 'current' ? 'bg-red-600 shadow-[0_0_15px_rgba(220,38,38,0.4)] text-white' : 'text-gray-500 hover:text-white'"
            class="px-8 py-2.5 rounded-full font-bold uppercase tracking-widest text-[10px] md:text-xs transition-all duration-300 active:scale-95"
          >
            Current
          </button>
          <button 
            @click="leaderboardView = 'previous'"
            :class="leaderboardView === 'previous' ? 'bg-red-600 shadow-[0_0_15px_rgba(220,38,38,0.4)] text-white' : 'text-gray-500 hover:text-white'"
            class="px-8 py-2.5 rounded-full font-bold uppercase tracking-widest text-[10px] md:text-xs transition-all duration-300 active:scale-95"
          >
            Previous
          </button>
        </div>

        <!-- Leaderboard Table -->
        <Motion :initial="{ y: 50, opacity: 0 }" :in-view="{ y: 0, opacity: 1 }" :in-view-options="{ once: true }" :transition="{ duration: 0.8, delay: 0.2 }" class="w-full bg-[#2a2a2a] border border-white/5 rounded-3xl overflow-x-auto shadow-2xl relative overflow-hidden">
          <div v-if="loading" class="py-20 flex flex-col items-center gap-4 text-white">
            <div class="w-10 h-10 border-4 border-red-600 border-t-transparent rounded-full animate-spin"></div>
            <span class="font-bold uppercase tracking-widest italic animate-pulse">Calculating Rankings...</span>
          </div>

          <table v-else class="w-full min-w-[800px] text-left border-collapse">
            <thead>
              <tr class="bg-white/5 border-b border-white/5">
                <th class="py-6 px-10 text-gray-500 font-black uppercase tracking-widest text-xs">Rank</th>
                <th class="py-6 px-10 text-gray-500 font-black uppercase tracking-widest text-xs">Username</th>
                <th class="py-6 px-10 text-gray-500 font-black uppercase tracking-widest text-xs">Wager</th>
                <th class="py-6 px-10 text-gray-500 font-black uppercase tracking-widest text-xs text-right">Winnings</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-white/5">
              <!-- Top 3 -->
              <tr v-for="(item, index) in activeTop3" :key="'top-'+index" 
                class="group transition-all duration-300 hover:bg-white/5"
                style="background: linear-gradient(90deg, rgba(245, 193, 108, 0.05) 0%, rgba(0, 0, 0, 0) 100%);">
                <td class="py-6 px-10">
                  <img v-if="index === 0" src="../assets/icon-gold.png" class="w-9 h-9" alt="gold">
                  <img v-else-if="index === 1" src="../assets/icon-silver.png" class="w-9 h-9" alt="silver">
                  <img v-else-if="index === 2" src="../assets/icon-bronze.png" class="w-9 h-9" alt="bronze">
                </td>
                <td class="py-6 px-10">
                  <div class="flex items-center gap-4">
                    <div class="w-10 h-10 rounded-full bg-red-600 flex items-center justify-center text-white font-bold text-lg">
                      {{ item.username.charAt(0).toUpperCase() }}
                    </div>
                    <span class="text-white font-bold text-lg tracking-tight">{{ getMaskstring(item.username) }}</span>
                  </div>
                </td>
                <td class="py-6 px-10">
                  <span class="text-gray-400 font-bold text-lg tracking-tight">${{ item.wagered.toLocaleString() }}</span>
                </td>
                <td class="py-6 px-10 text-right font-black">
                  <span :class="leaderboardView === 'current' ? 'text-[#F5C16C]' : 'text-white'" class="text-2xl italic tracking-tighter">
                    {{ leaderboardView === 'current' ? getLeaderboardRewardValue(index) : getPrevLeaderboardRewardValue(index) }}
                  </span>
                </td>
              </tr>
              <!-- Rest -->
              <tr v-for="(item, index) in activeRest" :key="'rest-'+index" class="group transition-all duration-300 hover:bg-white/5">
                <td class="py-6 px-10 text-gray-600 font-black text-xl italic opacity-60">
                 #{{ index + 4 }}
                </td>
                <td class="py-6 px-10">
                  <div class="flex items-center gap-4">
                    <div class="w-10 h-10 rounded-full bg-red-600 flex items-center justify-center text-white font-bold text-lg">
                      {{ item.username.charAt(0).toUpperCase() }}
                    </div>
                    <span class="text-white font-bold text-lg tracking-tight">{{ getMaskstring(item.username) }}</span>
                  </div>
                </td>
                <td class="py-6 px-10">
                  <span class="text-gray-400 font-bold text-lg tracking-tight">${{ item.wagered.toLocaleString() }}</span>
                </td>
                <td class="py-6 px-10 text-right font-black">
                  <span class="text-white text-xl italic tracking-tighter opacity-90">
                    {{ leaderboardView === 'current' ? getLeaderboardRewardValue(index + 3) : getPrevLeaderboardRewardValue(index + 3) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </Motion>

        <Motion :initial="{ y: 30, opacity: 0 }" :in-view="{ y: 0, opacity: 1 }" :in-view-options="{ once: true }" :transition="{ duration: 0.8 }" class="max-w-4xl w-full mt-12 bg-white/5 rounded-3xl p-8 border border-white/5">
          <p class="text-gray-400 text-sm leading-relaxed">
            Your wagers on <span class="text-white font-bold italic">Roobet</span> will count towards the leaderboard at the
            following weights based on the games you are playing. This helps prevent leaderboard abuse:
          </p>
          <div class="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="flex items-start gap-3">
              <div class="w-1.5 h-1.5 rounded-full bg-red-600 mt-2"></div>
              <p class="text-gray-500 text-xs">Games with RTP ≤ 97% contribute <span class="text-white font-bold">100%</span></p>
            </div>
            <div class="flex items-start gap-3">
              <div class="w-1.5 h-1.5 rounded-full bg-red-600 mt-2"></div>
              <p class="text-gray-500 text-xs">Games with RTP > 97% contribute <span class="text-white font-bold">50%</span></p>
            </div>
            <div class="flex items-start gap-3">
              <div class="w-1.5 h-1.5 rounded-full bg-red-600 mt-2"></div>
              <p class="text-gray-500 text-xs">Games with RTP ≥ 98% contribute <span class="text-white font-bold">10%</span></p>
            </div>
            <div class="flex items-start gap-3">
              <div class="w-1.5 h-1.5 rounded-full bg-red-600 mt-2"></div>
              <p class="text-gray-500 text-xs">Only slots and housegames (dice excluded) count.</p>
            </div>
          </div>
        </Motion>
      </div>
    </section>



    <section class="bg-black pt-40 pb-24 px-6" id="merch">
      <div class="max-w-7xl mx-auto">
        <Motion :initial="{ y: 50, opacity: 0 }" :in-view="{ y: 0, opacity: 1 }" :in-view-options="{ once: true }" :transition="{ duration: 0.8 }" class="relative bg-[#1a1a1a] border border-white/5 rounded-[40px] overflow-hidden flex flex-col md:flex-row items-stretch shadow-2xl">
          <!-- Left: Model Image -->
          <div class="relative w-full md:w-1/2 min-h-[500px] md:min-h-0">
            <img src="../assets/merch-model.png" class="absolute inset-0 w-full h-full object-cover object-top" alt="merch model">
            
            <!-- Limited Drop Badge -->
            <a href="https://vivsworld25.itemorder.com/shop/sale/" target="_blank" class="absolute bottom-10 left-10 bg-red-600 px-6 py-3 rounded-2xl flex items-center gap-3 shadow-xl hover:bg-red-500 transition-colors">
              <img src="../assets/tag-icon.png" class="w-5 h-5" alt="tag">
              <span class="text-white font-black uppercase tracking-widest text-sm">Limited Drop</span>
            </a>
          </div>

          <!-- Right: Content -->
          <div class="w-full md:w-1/2 p-10 md:p-16 flex flex-col items-start text-left justify-center">
            <div class="flex items-center gap-3 mb-6">
              <img src="../assets/shirt-icon.png" class="w-6 h-6" alt="shirt">
              <span class="text-red-500 font-black uppercase tracking-[0.3em] text-sm">Official Gear</span>
            </div>

            <h2 class="text-4xl md:text-7xl font-black uppercase tracking-tighter mb-8 leading-none">
              <span class="text-white">WEAR THE </span>
              <span class="text-red-600 block md:inline">HYPE</span>
            </h2>

            <p class="text-gray-400 text-base md:text-lg mb-12 leading-relaxed max-w-lg font-medium">
              Level up your style with the official VIVSTREAMS merch collection. Premium quality hoodies, tees, and accessories designed for the true high rollers. Don't miss out on the latest drop.
            </p>

            <a href="https://vivsworld25.itemorder.com/shop/sale/" target="_blank" class="group relative bg-red-600 hover:bg-red-500 text-white px-10 py-5 rounded-2xl font-black uppercase tracking-widest transition-all shadow-[0_0_35px_rgba(220,38,38,0.5)] active:scale-95 flex items-center gap-4 mb-16">
              <img src="../assets/shop-icon.png" class="w-6 h-6" alt="shop">
              <span class="text-white">Shop Collection</span>
            </a>

            <!-- Divider -->
            <div class="w-full h-px bg-white/5 mb-10"></div>

            <div class="grid grid-cols-2 gap-10 w-full">
              <div>
                <span class="text-white text-xl font-black block mb-1">Premium</span>
                <span class="text-gray-500 text-sm font-bold uppercase tracking-widest">Quality Materials</span>
              </div>
              <div>
                <span class="text-white text-xl font-black block mb-1">Global</span>
                <span class="text-gray-500 text-sm font-bold uppercase tracking-widest">Worldwide Shipping</span>
              </div>
            </div>
          </div>
        </Motion>
      </div>
    </section>

    <!-- Socials Section -->
    <section class="bg-black py-24 px-6" id="socials">
      <div class="max-w-7xl mx-auto flex flex-col items-center">
        <!-- Section Header -->
        <Motion :initial="{ y: 50, opacity: 0 }" :in-view="{ y: 0, opacity: 1 }" :in-view-options="{ once: true }" :transition="{ duration: 0.6 }" class="text-center mb-16">
          <h2 class="text-4xl md:text-6xl font-black uppercase tracking-tighter mb-4 leading-none">
            <span class="text-white">FOLLOW </span>
            <span class="text-red-600">MY SOCIALS</span>
          </h2>
          <p class="text-gray-400 text-base md:text-lg font-medium max-w-2xl mx-auto leading-relaxed">
            Never miss a live stream or giveaway. Join the community on your favorite platform.
          </p>
        </Motion>

        <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4 md:gap-6 w-full mb-12">
          <Motion as="a" v-for="(social, index) in socials" :key="social.name" :href="social.url" target="_blank"
            :initial="{ scale: 0.8, opacity: 0 }"
            :in-view="{ scale: 1, opacity: 1 }"
            :in-view-options="{ once: true }"
            :transition="{ duration: 0.4, delay: index * 0.1 }"
            class="group relative bg-[#151515] border border-white/5 rounded-2xl sm:rounded-[32px] p-4 sm:p-6 md:p-8 flex flex-col items-center justify-center transition-all duration-500 hover:border-red-600/50 hover:shadow-[0_0_40px_rgba(220,38,38,0.15)] overflow-hidden">
            
            <!-- Hover Gradient Background -->
            <div class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-gradient-to-b from-[#1a1a1a] via-[#1a1010] to-[#2a0a0a]"></div>

            <div class="relative mb-3 sm:mb-4 md:mb-6 z-10">
              <div class="w-14 h-14 sm:w-18 sm:h-18 md:w-24 md:h-24 rounded-full border border-white/5 flex items-center justify-center transition-all duration-500 group-hover:border-[currentColor]" :style="{ color: social.color + '4D' }">
                <img :src="require(`../assets/${social.icon}`)" :alt="social.name" class="w-7 h-7 sm:w-9 sm:h-9 md:w-12 md:h-12 object-contain relative z-10 transition-transform duration-500 group-hover:scale-110">
              </div>
              <!-- Subtle Glow -->
              <div class="absolute inset-0 blur-2xl opacity-10 group-hover:opacity-30 transition-opacity z-0 rounded-full" :style="{ backgroundColor: social.color }"></div>
            </div>

            <div class="relative z-10 flex flex-col items-center">
              <span class="text-white font-black text-sm sm:text-base md:text-xl tracking-tight">{{ social.name }}</span>
            </div>
          </Motion>
        </div>

        <!-- Discord CTA Card -->
        <Motion :initial="{ y: 50, opacity: 0 }" :in-view="{ y: 0, opacity: 1 }" :in-view-options="{ once: true }" :transition="{ duration: 0.8 }" class="w-full relative bg-gradient-to-b from-[#111111] to-[#250d0d] border border-red-600 rounded-[40px] p-8 md:p-12 overflow-hidden flex flex-col md:flex-row items-center justify-between gap-8 shadow-[0_0_30px_rgba(220,38,38,0.1)]">
          <div class="flex flex-col items-center text-center md:items-start md:text-left max-w-2xl relative z-10">
            <h3 class="text-3xl md:text-4xl font-black text-white mb-4 tracking-tight">Join the Discord Community</h3>
            <p class="text-gray-400 text-base md:text-lg font-medium leading-relaxed">
              Get notified when we go live, participate in community events, and chat with other fans.
            </p>
          </div>
          <a href="https://discord.com/invite/wXEZRuUnJP" target="_blank"
            class="relative z-10 bg-[#5865F2] hover:bg-[#4752C4] text-white px-10 py-5 rounded-2xl font-black uppercase tracking-widest transition-all shadow-[0_0_35px_rgba(88,101,242,0.4)] hover:shadow-[0_0_50px_rgba(88,101,242,0.6)] active:scale-95 whitespace-nowrap">
            Join Discord
          </a>
          <!-- Subtle Decorative Glow -->
          <div class="absolute -bottom-20 -right-20 w-80 h-80 bg-red-600/10 blur-[120px] rounded-full"></div>
        </Motion>
      </div>
    </section>


  </div>
</template>

<script>
import { defineComponent } from "vue";
import axios from "axios";
import moment from "moment-timezone";
import { Motion } from "motion-v";

export default defineComponent({
  components: {
    Motion,
  },
  data() {
    return {
      isLive: false,
      streamUrl: "https://kick.com/vivstreams",
      streamer: "vivstreams",

      // Main state
      currentLeaderboard: "roobet",
      leaderboardView: "current", // 'current' or 'previous'
      loading: false,

      // Leaderboard data
      leaderboardData: { leaderboard: [] },
      leaderboardPrevData: { leaderboard: [] },
      top3: [],
      topRest: [],
      topForMobile: [],
      
      displayedPrevLead: [],
      displayedPrevLeadMobile: [],
      prevloading: false,

      followersLoading: false,
      followersError: null,
      followers: {
        kick: null,
        youtube: null,
        instagram: null,
        facebook: null,
        twitter: null,
      },

      socials: [
        { name: "Kick", icon: "kick-icon.png", count: "500K", color: "#53FC18", url: "https://kick.com/vivstreams" },
        { name: "YouTube", icon: "youtube-icon.png", count: "1.2M", color: "#FF0000", url: "https://www.youtube.com/@VivStreams" },
        { name: "Twitter", icon: "twitter-icon.png", count: "250K", color: "#1DA1F2", url: "https://x.com/vivstreams?s=21" },
        { name: "Instagram", icon: "instagram-icon.png", count: "100K", color: "#E1306C", url: "https://www.instagram.com/vivstreams/" },
        { name: "Discord", icon: "discord-icon.png", count: "80K", color: "#5865F2", url: "https://discord.com/invite/wXEZRuUnJP" },
        { name: "Tiktok", icon: "tiktok-icon.png", count: "80K", color: "#fe2858", url: "https://www.tiktok.com/@vivstreamz?_r=1&_t=ZP-93NdIBP9VeB" },
      ],

      // Timer
      timer: "0d 0h 0m 0s",
      timerInterval: null,
      timeSegments: [
        { label: "DAYS", value: "0" },
        { label: "HRS", value: "0" },
        { label: "MIN", value: "0" },
        { label: "SEC", value: "0" },
      ],
      startDate: null,
      endDate: null,
      notFormattedEndDate: null,

      // Prizes
      animatedTotalPrize: 0,
    };
  },

  watch: {
    "$route.query.type"(newType) {
      if (["roobet", "stake", "shuffle", "thrill"].includes(newType)) {
        this.currentLeaderboard = newType;
      }
    },
    currentLeaderboard(newVal) {
      this.$router.replace({ query: { type: newVal } });
      this.fetchLeaderboard();
    },
    leaderboardView() {
      this.animateValues();
    },
  },
  computed: {
    currentPrizeTitle() {
      return `$${this.animatedTotalPrize.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`;
    },
    showPrevious() {
      const type = this.currentLeaderboard.toUpperCase();
      const envKey = `VUE_APP_SHOW_PREVIOUS_LEADERBOARD_${type}`;
      return process.env[envKey] !== 'false';
    },
    activeTop3() {
      if (this.leaderboardView === 'current') return this.top3;
      const prev = (this.leaderboardPrevData.leaderboard || []).filter(e => e.wagered > 0);
      return prev.slice(0, 3);
    },
    activeRest() {
      if (this.leaderboardView === 'current') return this.topRest;
      const prev = (this.leaderboardPrevData.leaderboard || []).filter(e => e.wagered > 0);
      return prev.slice(3, 5);
    }
  },
  methods: {
    formatCurrency(amount) {
      const n = Number(amount) || 0;
      return "$" + n.toLocaleString("en-US");
    },

    async checkStreamStatus() {
      try {
        const response = await fetch(`https://kick.com/api/v2/channels/${this.streamer}`);
        const data = await response.json();
        this.isLive = data?.livestream?.is_live ?? false;

        if (this.isLive) {
          this.streamUrl = `https://player.kick.com/${this.streamer}`;
        }
      } catch (error) {
        console.error("Error checking stream status:", error);
      }
    },

    async fetchLeaderboard() {
      this.loading = true;
      this.prevloading = true;
      this.resetLeaderboardState();

      try {
        const baseUrl = process.env.VUE_APP_BASE_API_DYNAMIC || process.env.VUE_APP_BASE_API;
        const apiKey = process.env.VUE_APP_X_API_KEY_DYNAMIC || process.env.VUE_APP_X_API_KEY;
        const secretKey = process.env.VUE_APP_X_SECRET_KEY;

        const headers = {
          "x-api-key": apiKey,
        };
        if (secretKey) headers["x-secret-key"] = secretKey;

        let currentUrl = `${baseUrl}/api/leaderboard/${this.currentLeaderboard}`;

        if (this.currentLeaderboard === 'roobet' && !process.env.VUE_APP_BASE_API_DYNAMIC) {
          currentUrl = `${baseUrl}/api/roobet/leaderboard`;
        }

        const currentRes = await axios.get(currentUrl, { headers });
        this.leaderboardData = currentRes.data || { leaderboard: [] };
        this.leaderboardData = this.normalizeLeaderboardData(this.leaderboardData);

        this.startDate = moment(this.leaderboardData.startDate).format("MMMM DD, YYYY");
        this.endDate = moment(this.leaderboardData.endDate).format("MMMM DD, YYYY");
        this.notFormattedEndDate = this.leaderboardData.endDate;

        if (this.showPrevious) {
          let prevUrl = `${baseUrl}/api/leaderboard/${this.currentLeaderboard}?previous=true`;

          if (this.currentLeaderboard === 'roobet' && !process.env.VUE_APP_BASE_API_DYNAMIC) {
            prevUrl = `${baseUrl}/api/roobet/leaderboard?previous=true`;
          }
          
          const prevRes = await axios.get(prevUrl, { headers });
          this.leaderboardPrevData = prevRes.data || { leaderboard: [] };
          this.leaderboardPrevData = this.normalizeLeaderboardData(this.leaderboardPrevData);
        }

        this.updateDisplayData();
        this.startTimer();
        this.animateValues();
      } catch (error) {
        console.error("Leaderboard fetch error:", error);
      } finally {
        this.loading = false;
        this.prevloading = false;
      }
    },

    resetLeaderboardState() {
      this.leaderboardData = { leaderboard: [] };
      this.leaderboardPrevData = { leaderboard: [] };
      this.top3 = [];
      this.topRest = [];
      this.topForMobile = [];
      this.displayedPrevLead = [];
      this.displayedPrevLeadMobile = [];
    },

    normalizeLeaderboardData(data) {
      if (!data?.leaderboard) return { leaderboard: [] };
      return {
        startDate: data.startDate,
        endDate: data.endDate,
        leaderboard: data.leaderboard.map((entry) => ({
          username: this.getUsername(entry, this.currentLeaderboard),
          wagered: this.getWageredAmount(entry),
        })),
      };
    },

    getUsername(entry, type) {
      if (type === "roobet") return entry.username || "";
      if (type === "stake") return entry.userName || "";
      if (type === "shuffle") return entry.username || "";
      if (type === "thrill") return entry.username || "";
      return entry.user_name || entry.username || "";
    },

    getWageredAmount(entry) {
      if (this.currentLeaderboard === "roobet") {
        return entry.weightedWagered || entry.wagered || 0;
      }
      if (this.currentLeaderboard === "stake") {
        const raw = entry.wagered || entry.total_wagered || "";
        const clean = raw.toString().replace(/[$,]/g, "");
        const value = parseFloat(clean);
        return isNaN(value) ? 0 : value;
      }
      if (this.currentLeaderboard === "thrill") {
        const value = Number(entry?.wager?.value || 0);
        const decimals = entry?.wager?.decimals || 18;
        return value / Math.pow(10, decimals);
      }
      return entry.wagered || entry.wagerAmount || 0;
    },

    updateDisplayData() {
      // Current Leaderboard display
      const current = (this.leaderboardData.leaderboard || []).filter(e => e.wagered > 0);
      this.top3 = current.slice(0, 3);
      this.topRest = current.slice(3, 5);
      this.topForMobile = current.slice(0, 5);

      // Previous Leaderboard display (for the separate section in template)
      const prev = (this.leaderboardPrevData.leaderboard || []).filter(e => e.wagered > 0);
      this.displayedPrevLead = prev.slice(0, 5);
      this.displayedPrevLeadMobile = prev.slice(0, 5);
    },

    getRewardValue(rank, isPrevious = false) {
      const type = this.currentLeaderboard.toUpperCase();
      const status = isPrevious ? "PREVIOUS" : "CURRENT";
      
      const specificKey = `VUE_APP_${type}_${status}_PRIZES`;
      const genericKey = `VUE_APP_${type}_${status}_LEADERBOARD_REWARDS`;
      
      const raw = process.env[specificKey] || process.env[genericKey] || "[]";
      let rewards = [];
      try {
        rewards = JSON.parse(raw);
      } catch (e) {
        rewards = [500, 250, 125, 75, 50];
      }

      if (rank >= rewards.length) {
        return this.currentLeaderboard === "raingg" ? "0c" : "$0";
      }

      const value = rewards[rank];
      return this.currentLeaderboard === "raingg" ? `${value}c` : `$${value}`;
    },
    
    getLeaderboardRewardValue(rank) { return this.getRewardValue(rank, false); },
    getPrevLeaderboardRewardValue(rank) { return this.getRewardValue(rank, true); },

    startTimer() {
      clearInterval(this.timerInterval);
      if (!this.notFormattedEndDate) {
        this.setZeroTimer();
        return;
      }

      const type = this.currentLeaderboard.toUpperCase();
      const period = process.env[`VUE_APP_${type}_TIMER_PERIOD`] || "month";

      const getNextTargetDate = () => {
        const now = moment().tz("America/New_York");
        let target = moment.utc(this.notFormattedEndDate).tz("America/New_York");
        
        if (now.isAfter(target)) {
          if (period === "week") target.add(1, "week");
          else if (period === "month") target.add(1, "month");
        }
        return target;
      };

      const targetDate = getNextTargetDate();
      const update = () => {
        const now = moment().tz("America/New_York");
        const dist = targetDate.diff(now);
        if (dist >= 0) {
          const dur = moment.duration(dist);
          const d = Math.floor(dur.asDays());
          const h = dur.hours();
          const m = dur.minutes();
          const s = dur.seconds();
          
          this.timer = `${d}d ${h}h ${m}m ${s}s`;
          this.timeSegments[0].value = d.toString();
          this.timeSegments[1].value = h.toString();
          this.timeSegments[2].value = m.toString();
          this.timeSegments[3].value = s.toString();
        } else {
          this.setZeroTimer();
          clearInterval(this.timerInterval);
        }
      };

      update();
      this.timerInterval = setInterval(update, 1000);
    },

    setZeroTimer() {
      this.timer = "0d 0h 0m 0s";
      this.timeSegments.forEach((segment) => (segment.value = "0"));
    },

    animateValues() {
      const type = this.currentLeaderboard.toUpperCase();
      const status = this.leaderboardView.toUpperCase(); // 'CURRENT' or 'PREVIOUS'
      const raw = process.env[`VUE_APP_${type}_${status}_PRIZES`] || "[]";
      let rewards = [];
      try { rewards = JSON.parse(raw); } catch (e) { rewards = []; }
      const total = rewards.reduce((sum, val) => sum + (Number(val) || 0), 0);
      this.animateNumber("animatedTotalPrize", total);
    },

    animateNumber(variable, target) {
      let current = this[variable] || 0;
      if (current === target) return;
      const step = Math.max(1, Math.abs(target - current) / 20);
      const isDown = current > target;
      const interval = setInterval(() => {
        current += isDown ? -step : step;
        if ((isDown && current <= target) || (!isDown && current >= target)) {
          current = target;
          clearInterval(interval);
        }
        this[variable] = parseFloat(current.toFixed(2));
      }, 50);
    },

    getMaskstring(string) {
      if (string) {
        const firstHalf = Math.ceil(Number(string.length / 2));
        const secondHalf = string.length - firstHalf;
        return string.slice(0, firstHalf) + "*".repeat(secondHalf);
      }
      return string;
    },

    getOrdinalSuffix(n) {
      const s = ["th", "st", "nd", "rd"],
        v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    },

    async fetchFollowers() {
      this.followersLoading = true;
      const base = process.env.VUE_APP_BASE_API_DYNAMIC || process.env.VUE_APP_BASE_API;
      const apiKey = process.env.VUE_APP_X_API_KEY_DYNAMIC || process.env.VUE_APP_X_API_KEY;
      const types = ["kick", "youtube"];

      try {
        const requests = types.map((t) =>
          axios.get(`${base}/api/followers/${t}`, {
            headers: { "x-api-key": apiKey },
          }).then((res) => ({ type: t, value: res.data?.data?.followersCount || null }))
            .catch(() => ({ type: t, value: null }))
        );
        const results = await Promise.all(requests);
        results.forEach(({ type, value }) => (this.followers[type] = value));
      } catch (e) {
        console.error("Followers fetch error:", e);
      } finally {
        this.followersLoading = false;
      }
    },
  },

  mounted() {
    this.checkStreamStatus();
    this.fetchLeaderboard();
    this.fetchFollowers();
  },
});
</script>

<style scope>
body {
  background-color: #0b0b0c;
}
.main-bg {
  background-image: url("../assets/combined-hero-section bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.social-bg {
  background-image: url("../assets/socials-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.leaderboard-bg {
  background-image: url("../assets/leaderboard-bg-grouped.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.prev-leaderboard-bg {
  background-image: url('../assets/previous-leaderboard-bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.challenges-bg {
  background-image: url('../assets/challenges-bg.png');
  background-repeat: no-repeat;
  background-size: cover;
}

/* .bg-hero-pattern {
  background-image: url("../assets/rules-bg.png");
} */

.font-acme {
  font-family: "Acme", sans-serif;
}

.font-angkor {
  font-family: "Angkor", sans-serif;
}

.font-cantarell {
  font-family: "Cantarell", sans-serif;
}

.list-square {
  list-style-type: square;
}
</style>

